<template>
  <t-login-service-ended v-if="finishCheckAuthen && loginDisabled" />
  <t-default-entry
    v-if="finishCheckAuthen && !loginDisabled"
    sub-heading="Login"
    heading="ログイン"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
    <div v-if="error" class="t-login__alert">
      <a-alert color="error" size="small" class="t-login__alert">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="errorMessage"></span>
      </a-alert>
    </div>
    <form class="t-login__form">
      <div class="t-login__group">
        <m-form-input class="t-login__input" label="契約ID">
          <a-text-field
            id="contractId"
            v-model="userInfo.companyID"
            type="text"
            name=""
            placeholder="012345"
            autocomplete="on"
          />
        </m-form-input>
        <m-form-input class="t-login__input" label="ユーザーID">
          <a-text-field
            id="operatorId"
            v-model="userInfo.userID"
            type="email"
            name=""
            placeholder="dummy@gmail.com"
            autocomplete="email"
          />
        </m-form-input>
        <m-form-input class="t-login__input" label="パスワード">
          <a-text-field
            id="password"
            v-model="userInfo.password"
            type="password"
            hidden
            name=""
            placeholder="********"
            autocomplete="current-password"
          />
          <template v-if="!isPoint" #note>
            <a-caption-list>
              <li>
                ログインできない方は
                <a-button variant="text" color="primary" href="#" @click="selfResetPassword">こちら</a-button>
              </li>
            </a-caption-list>
          </template>
        </m-form-input>
        <!-- <a-checkbox v-model="formData.remember" label="ログイン状態を保持する" name="login-checkbox" value="1" /> -->
      </div>
      <m-button-container class="t-login__buttons">
        <a-button id="login" variant="block" color="primary" @click="processLogin()">ログイン</a-button>
        <a v-if="isDAccountActive" :href="dAccountUrl">
          <img
            id="bussinessDAccount"
            class="daccount_button"
            src="@/images/pages/business_d_account_logo.svg"
            alt="ビジネスdアカウント"
        /></a>
        <a-button id="trialCall" variant="block" color="primary" @click="outgoingPreflightTestHandler()"
          >お試し通話の方はこちら</a-button
        >
        <!-- <a-button color="primary" @click="handleNoAccountClick">アカウントをお持ちでない方はこちら</a-button>-->
      </m-button-container>
    </form>
    <teleport to="body">
      <o-modal
        id="login_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
        <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="modal-ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAlert from '@/components/atoms/alert';
import AButton from '@/components/atoms/button';
import TLoginServiceEnded from './service-ended.vue';
import ATextField from '@/components/atoms/text-field';
import MButtonContainer from '@/components/molecules/button-container';
import MFormInput from '@/components/molecules/form-input';
import TDefaultEntry from '@/components/templates/default-entry';
import { cloneDeep } from 'lodash';
import { showMsgBoxMixin } from '@/common/showMsgBox.js';
import { mapActions } from 'vuex';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { Device, PreflightTest } from '@twilio/voice-sdk';
import Loading from 'vue-loading-overlay';

export default {
  name: 't-login',
  components: {
    AAlert,
    AButton,
    TLoginServiceEnded,
    ATextField,
    MButtonContainer,
    MFormInput,
    TDefaultEntry,
    Loading,
  },
  mixins: [showMsgBoxMixin, customValidate, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
    // handleNoAccountClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data: function () {
    return {
      userInfo: {
        companyID: '',
        userID: '',
        password: '',
        remember: true,
      },
      loginErrorMsg: '',
      error: false,
      errorMessage: '',
      finishCheckAuthen: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      dAccountUrl: null,
      validFlag: true,
      isLoading: false,

      //Twilio
      preflightTest: null,

      // modal
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      isDAccountActive: false,
      isPoint: false,
      loginDisabled: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-login', this.error ? 'error' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created: function () {
    this.sessionCheck();
    if (this.$route.params.errorMessage) {
      this.error = true;
      this.errorMessage = this.$route.params.errorMessage;
    }
  },
  methods: {
    ...mapActions(['updateLoginInfo']),
    async sessionCheck(doingLogin = false) {
      await this.postRequest('/sessioncheck')
        .then(res => {
          if (res.loginDisabled) {
            this.loginDisabled = true;
            this.finishCheckAuthen = true;
            return;
          }
          if (res.codeAuthFlag && this.$route.query.XNcomSignature) {
            // コード認証の場合メールリンク認証は無効になります
            this.$router.push({ path: '/notfound' });
            return;
          }
          if (res.status === 'invalidCsrfToken') {
            // refresh csrf token
            this.csrfToken = res.newCsrfToken;
            document.querySelector('meta[name="csrf-token"]').setAttribute('content', res.newCsrfToken);
            this.finishCheckAuthen = true;
            return;
          }
          if (doingLogin) return;
          if (res.dAccountParams) {
            document.querySelector('meta[name="d-account-state"]').setAttribute('content', res.dAccountParams['state']);
            document.querySelector('meta[name="d-account-nonce"]').setAttribute('content', res.dAccountParams['nonce']);
          }
          const params = new URLSearchParams();
          for (const key in res.dAccountParams) params.append(key, res.dAccountParams[key]);
          this.dAccountUrl = `${res.dAccountUrl}?${params.toString()}`;
          this.isDAccountActive = res.isDAccountActive;
          this.isPoint = res.isPoint ? true : false;
          if (res.session) {
            if (res.tempPwdFlag) {
              this.postRequest('/login/logout').then(data => {
                if (data.status === 'success') {
                  window.location.href = '/login';
                } else {
                  this.showErrorModal(messageContent.requireTry('ログアウト'));
                }
              });
            } else if (res.firstVisitFlag && res.authInfo === 'supervisor') {
              // ウォークスルーページはマスタ管理者のみアクセス可能
              this.$router.push({ name: 'WTInviteUser' });
            } else {
              this.$router.push({ name: 'Home' });
            }
          } else {
            this.finishCheckAuthen = true;
          }
        })
        .catch(err => {
          this.finishCheckAuthen = true;
          console.log(err);
          this.setError(messageContent.requireTry('検索'));
        });
    },
    processLogin: async function () {
      this.errorMessage = '';
      this.error = false;
      //check required
      if (!this.userInfo.companyID || !this.userInfo.userID || !this.userInfo.password) {
        this.errorMessage = messageContent.loginInputError;
        this.error = true;
      }
      //契約ID桁数チェック
      else if (this.userInfo.companyID.length !== 6 && this.userInfo.companyID.length !== 9) {
        this.errorMessage = messageContent.loginCompanyIdDigitError;
        this.error = true;
      }
      //check companyID
      else if (!this.userInfo.companyID.match(/^[0-9]{6}$/) && !this.userInfo.companyID.match(/^tri[0-9]{6}$/)) {
        this.errorMessage = messageContent.loginCompanyIdFormatError;
        this.error = true;
      }
      //check email format
      else if (!this.addressCheck(this.userInfo.userID)) {
        this.errorMessage = messageContent.loginEmailInputError;
        this.error = true;
      }
      //特殊文字をチェック
      else if (this.hasSpecialCharacterInString(this.userInfo.password)) {
        this.errorMessage = messageContent.hasSpecialCharacter;
        this.error = true;
      } else {
        this.isLoading = true;
        // ログインする前にCSRFトークンの有効期限を確認する
        await this.sessionCheck(true);

        const formDataTmp = {
          companyID: this.userInfo.companyID,
          userID: this.userInfo.userID,
          password: this.userInfo.password,
          _csrf: this.csrfToken,
          authCode: this.$route.query.XNcomSignature,
        };
        const formData = JSON.stringify(formDataTmp);
        await fetch('/login', {
          method: 'POST',
          body: formData,
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(response => {
            if (response.status === 403) {
              return {
                session: false,
                status: 'csrfExpired',
                msg: messageContent.loginCsrfExpiredError,
              };
            } else if (!response.ok && response.status !== 429) {
              throw new Error('/login response was not ok.');
            } else {
              return response.json();
            }
          })
          .then(e => {
            if (e.session) {
              // Update new csrf token due to new session is generated(old one be expired).
              document.querySelector('meta[name="csrf-token"]').setAttribute('content', e.token);
              this.updateLoginInfo(e.data);
              const trueValues = ['true', 'TRUE', 'True'];
              // When chouan value in .yaml config file set to true, may be the value can be changed to one of value in trueValues
              this.setCookie('chouan', e.data.chouan === true || trueValues.includes(e.data.chouan) ? 1 : 0);
              this.setCookie('notifyMessageDisplayFlag', 'ON');
              if (e.data.firstVisitFlag && e.data.authInfo === 'supervisor') {
                // ウォークスルーページはマスタ管理者のみアクセス可能
                this.$router.push({ name: 'WTInviteUser' });
              } else {
                window.location.href = '/home';
              }
            } else if (!e.session && e.status === 'twoFactorAuthenticating') {
              //仮パスワードの場合
              this.$router.push({
                name: 'LoginPasscodeInput',
                params: { companyID: this.userInfo.companyID, userID: this.userInfo.userID },
              });
            } else if (!e.session && e.status === 'resetPassword') {
              //仮パスワードの場合
              this.$router.push({ path: '/resettemppassword' });
            } else if (!e.session && e.status === 'duringMailAuth') {
              //メールリンク認証中の場合、ログインできません。
              this.$router.push({ path: '/no-mail-auth' });
            } else if (!e.session && e.status === 'createdMailLink') {
              //有効期限切りになると、メールリンク認証を作成、認証リンクをメールで送信
              this.isLoading = false;
              const modalMessage = e.tempPwdFlag
                ? messageContent.loginEmailAuthSend
                : messageContent.loginEmailAuthResend;
              this.showInfoModal(modalMessage);
            } else if (!e.session && (e.status === 'mailLinkInvalid' || e.status === 'mailLinkCountFail')) {
              //認証コードが間違い
              this.$router.push({ path: '/error' });
            } else if (!e.session && e.status === 'loginFailed') {
              this.isLoading = false;
              this.errorMessage = e.msg;
              this.error = true;
            } else if (!e.session && e.status === 'rateLimit') {
              this.isLoading = false;
              this.errorMessage = e.msg;
              this.error = true;
            } else if (!e.session && e.status === 'csrfExpired') {
              this.isLoading = false;
              this.errorMessage = e.msg;
              this.error = true;
            } else {
              this.isLoading = false;
              this.errorMessage = messageContent.loginOtherError;
              this.error = true;
            }
          })
          /* eslint-disable no-unused-vars*/
          .catch(error => {
            this.isLoading = false;
            this.errorMessage = messageContent.loginOtherError;
            this.error = true;
          });
      }
    },
    setCookie(key, value, expires = null) {
      if (!expires) {
        const d = new Date();
        // Cookie expires after 3 days
        d.setTime(d.getTime() + 3 * 24 * 60 * 60 * 1000);
        expires = 'expires=' + d.toUTCString();
      }
      document.cookie = `${key}=${value};expires=${expires}`;
    },
    outgoingPreflightTestHandler() {
      this.errorMessage = '';
      this.error = false;
      const self = this;
      this.postRequest('/tokentest')
        .then(data => {
          const options = {
            edge: 'tokyo',
          };
          this.preflightTest = Device.runPreflight(data.data.token, options);
          this.preflightTest.on(PreflightTest.Events.Completed, report => {});

          this.preflightTest.on(PreflightTest.Events.Failed, error => {
            this.errorMessage = messageContent.loginTestCallError;
            this.error = true;
          });
        })
        .catch(error => {
          this.errorMessage = messageContent.loginTestCallError;
          this.error = true;
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    selfResetPassword() {
      this.$router.push({ name: 'CanNotLogin' });
    },
  },
};
</script>
